var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"500","sub-title":"Coś poszło nie tak! Przepraszamy za problemy. Spróbuj ponownie później.","title":"500"}})
}
var staticRenderFns = []

export { render, staticRenderFns }